import { render } from "./StatsSection.vue?vue&type=template&id=10065714&scoped=true&ts=true"
import script from "./StatsSection.vue?vue&type=script&lang=ts"
export * from "./StatsSection.vue?vue&type=script&lang=ts"

import "./StatsSection.vue?vue&type=style&index=0&id=10065714&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10065714"]])

export default __exports__